































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class UploadIcon extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
